import React from 'react';
import { path, pathOr } from 'ramda';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import { ACTION_CODES } from 'constants/errors';
import AgentPortalError from 'errors/AgentPortalError';
import { getBookingJourneysURL } from 'utils/urls';

import { FullPageSpinner } from 'admin-components/components';
import { useCurrencyFromURL } from 'utils/hooks/currency';
import RefundMethods from './RefundMethods';

import { GET_BOOKING, GET_USER } from './graphql';

const RefundMethodsContainer = ({ match }) => {
  const { reference } = match.params;

  const userState = useQuery(GET_USER);

  const user = pathOr({}, ['data', 'me'], userState);

  const [currency, changeCurrency] = useCurrencyFromURL(user.paymentCurrencies);

  const bookingState = useQuery(GET_BOOKING, {
    variables: { reference, currency },
    fetchPolicy: 'network-only'
  });

  const booking = path(['data', 'booking'], bookingState);

  const state = [userState, bookingState];
  const error = state.map((item) => item.error).find(Boolean);
  const loading = state.some((item) => item.loading);

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: getBookingJourneysURL(reference)
    });
  }

  if (loading) {
    return <FullPageSpinner />;
  }

  return <RefundMethods currency={currency} booking={booking} user={user} onCurrencyChange={changeCurrency} />;
};

RefundMethodsContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      reference: PropTypes.string.isRequired
    })
  })
};

export default RefundMethodsContainer;
